import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { AnchorComponent } from '../anchor/anchor.component';
import { NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-popover',
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, MatIconModule, AnchorComponent, NgbPopoverModule]
})
export class PopoverComponent implements OnInit {
  @Input() header?: string;
  @Input() icon?: string;
  @Input() iconClass?: string;
  @Input() linkText?: string;
  @Input() labelText?: string;
  @Input() onHover = false;
  @Input() preferDisplayAbove = false;
  @Input() popoverClass = 'popover';
  @Input() enabled = true;
  @Input() preferDisplayRight = false;
  @Input() preferDisplayLeft = false;

  @Input() placement = 'bottom';
  @Input() positionTarget: string | undefined = undefined;

  ngOnInit(): void {
    if (this.preferDisplayAbove) this.placement = 'top';
    if (this.preferDisplayRight) this.placement = 'right';
    if (this.preferDisplayLeft) this.placement = 'left';
  }
}
